import ActionIconToggle from './ActionIconToggle.connect';

export default ActionIconToggle;
